/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Handle ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async ($form, event) => {
  event.preventDefault();

  // $form.classList.add("loading");

  let response;

  const subscriptionInputType = $form.querySelector(
    "input#recharge-widget-type-subscription"
  );
  const trialSubscriptionInputType = $form.querySelector(
    "input#recharge-widget-type-trial-subscription"
  );

  if (
    (subscriptionInputType && subscriptionInputType.checked) ||
    (trialSubscriptionInputType && trialSubscriptionInputType.checked)
  ) {
    const id = Number($form.querySelector('[name="id"]').value);

    const rangeElement = $form.querySelector(
      '[name="recharge-widget-schedule"]'
    );
    const subPlansValueIds = rangeElement.dataset.valueIds.split(",");
    subPlansValueIds.filter((item) => item);

    const selectedSellingPlanId =
      subPlansValueIds[subPlansValueIds.length - rangeElement.value] || null;
    // console.log(selectedSellingPlanId)

    const formData = {
      items: [
        {
          id: id,
          quantity: 1,
          selling_plan: selectedSellingPlanId,
        },
      ],
    };
    response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });
  } else {
    response = await fetch("/cart/add.js", {
      method: "POST",
      body: new FormData($form),
    });
    const data = await response.json();

    if (data.quantity > 1) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: data.key,
          quantity: data.quantity ? data.quantity : 1,
        }),
      });
    }
    $.getJSON("/cart.js", function (result) {
      let has_discount_code = false;
      console.log(result);
      // Get parameters from the current URL
      let url = new URL(window.location.href);
      let urlParams = url.searchParams;
      let discountCode = urlParams.get("discount");

      let utmParams = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
      ];
      let utmString = "";

      utmParams.forEach(function (param) {
        if (urlParams.has(param)) {
          utmString +=
            (utmString === "" ? "?" : "&") + param + "=" + urlParams.get(param);
        }
      });

      $.each(result.items, async function (i, field) {
        if (discountCode) {
          if (
            result.items[i].id == 43944315551969 ||
            result.items[i].id == 43944315617505
          ) {
            let discountSlug = "/discount/" + discountCode;
            await fetch(discountSlug);
            window.location.href = "/checkout" + utmString;
            has_discount_code = true;
          }
        } else if (
          result.items[i].id == 43237929550049 ||
          result.items[i].id == 43764507803873
        ) {
          await fetch("/discount/SWEATCOIN");
          window.location.href = "/checkout";
          has_discount_code = true;
        } else if (
          result.items[i].id == 43548136014049 ||
          result.items[i].id == 43764561445089
        ) {
          await fetch("/discount/FREETRIAL");
          window.location.href = "/checkout";
          has_discount_code = true;
        } else if (
          result.items[i].id == 43944315551969 ||
          result.items[i].id == 43944315617505
        ) {
          await fetch("/discount/CLEANOCEANS");
          window.location.href = "/checkout" + utmString;
          has_discount_code = true;
        }
      });
      // if(!has_discount_code){
      //   window.location.href = '/checkout';
      // }
    });
  }

  if (!response.ok) {
    setTimeout(() => {
      document
        .querySelector("#offcanvas-cart")
        .querySelector(".offcanvas-body")
        .insertAdjacentHTML(
          "afterbegin",
          `
                <p 
                    class="alert alert-warning small mx-4"
                    style="border-radius: 0; line-height: normal;">
                    Something went wrong! The product might be out of stock. Please try again later. If the issue persist please <a href="/pages/contact">contact us</a>
                </p>
            `
        );
    }, 1500);
  }

  if (!$form.closest(".product-page-free-trial-v2")) {
    $form.classList.remove("loading");
    loadOffcanvasCart();
    addFreeProductToCart();
  }
};

// Offcanvas cart - load it on ajax add/update
export const loadOffcanvasCart = async () => {
  const offcanvasCart = document.querySelector("#offcanvas-cart");
  const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart);
  const offcanvasBody = offcanvasCart.querySelector(".offcanvas-body");

  offcanvasCart.classList.add("loading");

  if (!offcanvasCart.classList.contains("show")) {
    bsOffcanvas.show();
  }

  const respoonse = await fetch(window.location.href);
  const data = await respoonse.text();

  const parser = new DOMParser();
  const newDocument = parser.parseFromString(data, "text/html");

  offcanvasBody.replaceWith(
    newDocument.querySelector("#offcanvas-cart .offcanvas-body")
  );
  offcanvasCart
    .querySelector("#cart-subtotal-value")
    .replaceWith(newDocument.querySelector("#cart-subtotal-value"));
  offcanvasCart.classList.remove("loading");

  document.querySelectorAll(".cart-count-badge").forEach((badge) => {
    badge.textContent =
      newDocument.querySelector(".cart-count-badge").textContent;
  });

  initQuantityInputs();
  initRemoveButtons();
  initCheckoutButton();
  initCartGoal();
};

// Quantity inputs
const initQuantityInputs = () => {
  document.querySelectorAll('select[name="updates[]"]').forEach((select) => {
    select.addEventListener("change", async (e) => {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: select.dataset.lineItemKey,
          quantity: select.value,
        }),
      });
      if (document.body.classList.contains("request-page-type-cart")) {
        window.location.reload();
      } else {
        loadOffcanvasCart();
        updateFreeProductUpsell();
      }
    });
  });
};
initQuantityInputs();

// Remove buttons
const initRemoveButtons = () => {
  document.querySelectorAll(".btn-remove-line-item").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: btn.dataset.lineItemKey,
          quantity: 0,
        }),
      });
      loadOffcanvasCart();
      updateFreeProductUpsell();
    });
  });
};
initRemoveButtons();

// Checkout button - Indicate loading on click
const initCheckoutButton = () => {
  document
    .querySelectorAll('form[action="/cart"] .btn-checkout')
    .forEach((btn) => {
      btn.addEventListener("click", (e) => {
        btn.style.height = btn.clientHeight + "px";
        btn.innerHTML = `
                    <div 
                        class="spinner-border spinner-border-sm" 
                        role="status"
                        style="width: 1.2rem; height: 1.2rem">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                `;
      });
    });
};
initCheckoutButton();

// Footer Upsell (SmartShyp)
const iniFooterUpsell = async () => {
  const checkbox = document.querySelector(
    "#offcanvas-cart-footer-upsell-checkbox"
  );

  const isAlreadyInCart = async () => {
    const response = await fetch("/cart.json");
    const data = await response.json();

    return data.items.some(
      (item) => item.id === Number(checkbox.dataset.variantId)
    );
  };

  if (checkbox) {
    checkbox.addEventListener("change", async () => {
      if (checkbox.checked) {
        const isInCart = await isAlreadyInCart();

        if (!isInCart) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: checkbox.dataset.variantId,
              quantity: 1,
            }),
          });
        }
      } else {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: checkbox.dataset.variantId,
            quantity: 0,
          }),
        });
      }
      loadOffcanvasCart();
    });

    setTimeout(async () => {
      const userHasSelectedBefore = localStorage.getItem(
        "smartshyp_user_has_selected"
      );
      if (!userHasSelectedBefore) {
        const isInCart = await isAlreadyInCart();

        if (!isInCart) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: checkbox.dataset.variantId,
              quantity: 1,
            }),
          });
          localStorage.setItem("smartshyp_user_has_selected", true);

          checkbox.checked = true;

          const respoonse = await fetch(window.location.href);
          const data = await respoonse.text();

          const parser = new DOMParser();
          const newDocument = parser.parseFromString(data, "text/html");

          document
            .querySelector("#cart-subtotal-value")
            .replaceWith(newDocument.querySelector("#cart-subtotal-value"));
        }
      }
    }, 2000);
  }
};
iniFooterUpsell();

// Cart Goal - Animate width
const initCartGoal = () => {
  const progressBar = document.querySelector("#cart-goal .progress-bar");
  if (progressBar) {
    setTimeout(() => {
      progressBar.style.width = progressBar.dataset.width;
    }, 250);
  }
};
initCartGoal();

// Offcanvas cart - Open it if URL contains '#cart'
if (window.location.hash.includes("#cart")) {
  const offcanvasCart =
    bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart");
  offcanvasCart.show();
}

// Shuffle (randomize) upsell product lists in the offcanvas cart
const shuffleOffcanvasCartUpsells = () => {
  const list1 = document.querySelector("#cart-single-product-upsell");
  if (list1) {
    for (let i = list1.children.length; i >= 0; i--) {
      list1.appendChild(list1.children[(Math.random() * i) | 0]);
    }
  }

  const list2 = document.querySelector("#offcanvas-cart-upsell-collection");
  if (list2) {
    for (let i = list2.children.length; i >= 0; i--) {
      list2.appendChild(list2.children[(Math.random() * i) | 0]);
    }
  }
};
shuffleOffcanvasCartUpsells();

// Set Free Product handle in localStorage
const setFreeProductInLocalStorage = () => {
  const params = new URLSearchParams(location.search);

  if (params.get("free-product-id")) {
    localStorage.setItem("free_product_id", params.get("free-product-id"));
  }
};
setFreeProductInLocalStorage();

// Add Free Product upsell to cart
const addFreeProductToCart = async () => {
  if (!window.free_product_upsell) {
    return;
  }

  if (!localStorage.getItem("free_product_id")) {
    return;
  }

  const mainProductId = window.free_product_upsell.main_product_id;

  let freeProductVariantId =
    window.free_product_upsell.free_product_1.variant_id;

  if (
    Number(localStorage.getItem("free_product_id")) ===
    window.free_product_upsell.free_product_2.id
  ) {
    freeProductVariantId = window.free_product_upsell.free_product_2.variant_id;
  }

  const response = await fetch("/cart.json");
  const cart = await response.json();
  console.log(cart);

  const isMainProductInCart = cart.items.some((item) =>
    item.title.includes("Detergent Strips")
  );

  if (!isMainProductInCart) {
    return;
  }

  let isMainProductSubcription = false;

  cart.items.forEach((item) => {
    if (item.title.includes("Detergent Strips")) {
      if (item.selling_plan_allocation) {
        isMainProductSubcription = true;
      }
    }
  });

  if (!isMainProductSubcription) {
    return;
  }

  const IsFreeProductInCart = cart.items.some(
    (item) => item.variant_id === freeProductVariantId
  );

  if (!IsFreeProductInCart) {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: freeProductVariantId,
        quantity: 1,
      }),
    });
  }

  loadOffcanvasCart();
};

// Update Free Product Upsells within the cart
const updateFreeProductUpsell = async () => {
  if (!window.free_product_upsell) {
    return;
  }

  if (!localStorage.getItem("free_product_id")) {
    return;
  }

  const mainProductId = window.free_product_upsell.main_product_id;

  const response = await fetch("/cart.json");
  const cart = await response.json();
  console.log(cart);

  const isMainProductInCart = cart.items.some(
    (item) => item.product_id === mainProductId
  );

  if (isMainProductInCart) {
    return;
  }

  cart.items.forEach(async (item) => {
    if (
      item.variant_id === window.free_product_upsell.free_product_1.variant_id
    ) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: window.free_product_upsell.free_product_1.variant_id.toString(),
          quantity: 0,
        }),
      });
      loadOffcanvasCart();
    }
    if (
      item.variant_id === window.free_product_upsell.free_product_2.variant_id
    ) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: window.free_product_upsell.free_product_2.variant_id.toString(),
          quantity: 0,
        }),
      });
      loadOffcanvasCart();
    }
  });
};
